import { API } from '@consts/urls';
import axios from 'axios';
import { createUri, Api } from './utils';

const DATA_URL = createUri(Api.ReportsV2, '/ins/V1');

export const dataApi = axios.create({
    baseURL: DATA_URL,
});

const handleFetch = async (url: string, token: string, params?: { [key: string]: any }): Promise<any> => {
    const resp = await dataApi
        .get(url, {
            params,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .catch(async () => {
            return null;
        });

    return resp ? resp.data : null;
};

export const fetchReport = async (reportType: string, token: string, params?: { [key: string]: any }): Promise<any> => {
    const url: string = API[reportType];

    return await handleFetch(url, token, params);
};
